export enum CircleIconStatus {
  COMPLETED = "COMPLETED",
  ACTIVE = "ACTIVE",
  NONE = "NONE",
}
export interface CircleIconProps {
  status: CircleIconStatus;
  value: number;
}
